import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "grid grid-cols-8 gap-2 md:gap-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-8 md:col-span-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "dropzone-file",
    class: "form-label text-gray-600 text-sm m-0"
  }, " Pictures ")
], -1)
const _hoisted_3 = { class: "col-span-8 md:col-span-5" }
const _hoisted_4 = {
  key: 0,
  class: "images-preview mb-2 flex flex-wrap"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: "absolute top-0 left-0 w-full h-full rounded-lg flex items-center justify-center opacity-0 hover:opacity-100",
  style: {"background":"rgba(0, 0, 0, 0.4)"}
}
const _hoisted_8 = { class: "flex justify-start items-center w-full" }
const _hoisted_9 = {
  for: "dropzone-file",
  class: "flex flex-col justify-start items-center w-full md:w-1/2 h-36 bg-gray-50 rounded-lg border-2 border-gray-300 border-dashed cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
}
const _hoisted_10 = { class: "flex flex-col justify-center items-center pt-5 pb-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 text-sm text-gray-500 dark:text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Click to upload"),
  /*#__PURE__*/_createTextVNode(" or drag and drop ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, " SVG, PNG, JPG or GIF (MAX. 800x400px) ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_CloudUploadIcon = _resolveComponent("CloudUploadIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (image) => {
              return (_openBlock(), _createElementBlock("div", {
                key: image.id,
                class: _normalizeClass(["image-preview w-20 h-20 flex-shrink-0 mr-2 mb-2 cursor-pointer relative", { 'opacity-40 pointer-events-none': _ctx.removedImages.includes(image.id) }]),
                onClick: ($event: any) => (_ctx.removeImage(image.id))
              }, [
                _createElementVNode("img", {
                  src: image.remoteUrl,
                  alt: "image",
                  class: "w-full h-full object-cover rounded-lg"
                }, null, 8, _hoisted_6),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_XIcon, { class: "text-white w-6 h-6" })
                ])
              ], 10, _hoisted_5))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_CloudUploadIcon, { class: "mb-3 w-10 h-10 text-gray-400" }),
            _hoisted_11,
            _hoisted_12
          ]),
          _createElementVNode("input", {
            id: "dropzone-file",
            type: "file",
            class: "hidden",
            accept: "image/*",
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleImage($event))),
            multiple: ""
          }, null, 32)
        ])
      ]),
      (_ctx.files.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.files, (file, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "bg-indigo-100 text-indigo-500 py-2 px-3 text-sm rounded-md inline-flex items-center mt-2 mr-2",
              key: index
            }, [
              _createTextVNode(_toDisplayString(file.name) + " ", 1),
              _createVNode(_component_XIcon, {
                class: "w-3 h-4 ml-2 cursor-pointer",
                onClick: ($event: any) => (_ctx.removeFileFromQueue(file.name))
              }, null, 8, ["onClick"])
            ]))
          }), 128))
        : _createCommentVNode("", true)
    ])
  ]))
}